<script>
    import R from "../../lib/requests";
    import {clickOutside} from '../../lib/clickOutside.js';
    import {createEventDispatcher} from 'svelte/internal';
    import AppIcon from "../icons/AppIcon.svelte";
    import ControlLoader from "../ControlLoader.svelte";
    import {setFocusTo} from "../../lib/lib";

    export let id = null;
    export let object = null;
    export let value = null;
    export let css = '';
    export let placeholder = '';
    export let disabled = false;

    let oldValue = value;
    let timer;
    let results = [];
    let listIndex = -1;
    let showDropdown = false;
    let showNotFound = false;
    let loading = false;

    const dispatch = createEventDispatcher();

    const search = () => {
        const onSuccess = result => {
            results = result;
            loading = false;
            showNotFound = results.length === 0;
            openDropdown();
        }

        const onFailure = err => {
            loading = false;
        };

        loading = true;

        let data = {object, name:value};

        R.handle(R.autocomplete.search, data, onSuccess, onFailure);
    }

    const onKeyDown = (event) => {
        if (results && results.length) {
            if (event.key === 'ArrowDown') {
                event.preventDefault();
                listIndex++;
                if (listIndex >= results.length) {
                    listIndex = 0;
                }
            } else if (event.key === 'ArrowUp') {
                event.preventDefault();
                listIndex--;
                if (listIndex < 0) {
                    listIndex = results.length - 1;
                }
            } else if (event.key === 'Enter') {
                event.preventDefault();
                if (timer) {
                    clearInterval(timer);
                }
                if (listIndex > -1) {
                    onSelect(results[listIndex]);
                } else {
                    closeDropdown();
                }
            } else if (event.key === 'Escape') {
                closeDropdown();
            }
        }
    }

    const onKeyUp = (event) => {
        if (oldValue != value) {
            showNotFound = false;
            oldValue = value;
            if (timer) {
                clearInterval(timer);
            }

            if (value.length) {
                timer = setInterval(() => {
                    clearInterval(timer);
                    search();
                }, 500);
            } else {
                clear();
            }
        }
    }


    const onChange = event => {
        oldValue = value;
        dispatch("change", value);
    }

    const clear = () => {
        value = null;
        oldValue = null;
        showNotFound = false;
        dispatch("change");
    }

    const onSelect = (item) => {
        value = item;
        oldValue = item;
        dispatch("change", value);
        closeDropdown();
    }

    const onClear = () => {
        clear();
        value = "";
        setFocusTo(id);
    }

    const openDropdown = () => {
        showDropdown = true;
    }

    const closeDropdown = () => {
        showDropdown = false;
    }
</script>

<div class="dropdown-container" use:clickOutside on:click_outside="{ closeDropdown }">
    <div class="form-item">
        <input type="text" class="form-control {css}" id="{ id }" bind:value="{value}" on:keydown="{ onKeyDown }"
               on:keyup="{ onKeyUp }"
               on:change={ onChange }
               autocomplete="off"
               {placeholder} {disabled}>
        {#if showNotFound}
            <div class="not-found">
                <AppIcon icon="exclamation-circle-solid" size="16"/>
            </div>
        {:else}
            <div class="caret">
                <AppIcon icon="chevron-down" size="16"/>
            </div>
        {/if}
    </div>
    <ControlLoader {loading}/>

    {#if showDropdown}
        {#if results.length}
            <ul class="dropdown client-dropdown">
                {#each results as item, index}
                    <li class="dropdown-item d-flex align-items-center pointer" class:selected="{ listIndex === index }"
                        on:click="{ () => onSelect(item) }">
                        { item }
                    </li>
                {/each}
            </ul>
        {/if}
    {/if}
</div>

<style>
    .not-found {
        position: absolute;
        top: 50%;
        right: 10px;
        transform: translateY(-50%);
        color: rgba(0, 0, 0, 0.2);
    }

    .caret {
        position: absolute;
        top: 50%;
        right: 10px;
        transform: translateY(-50%);
        color: rgba(0, 0, 0, 0.5);
    }
</style>